module.exports = __webpack_public_path__ + "static/media/bg_deposit_balance.8d22fd58.png";